import {handleHttpResponse} from "../utils/http-helpers";
import {ApiUrl} from "../utils/portal-urls";

export async function getActiveBatchProgress(source, setLoading, setMsg){
    setLoading(true);
    return await fetch(ApiUrl.Batch.getAllActiveBatch.getPath)
        .then(handleHttpResponse)
        .catch( (err) => {
            setLoading(false);
            if (err) {
                console.error("Failed to fetch all active batch, " + err);
                setMsg({ open: true, msg: 'Failed to Fetch All Active Process.', msgLv: 'error'});
            }
        })
        .then( res => {
            setLoading(false);
            if (res) {
                const activeBatch = res.filter( batch => batch.type.includes(source));
                return activeBatch[0];
            }
        })
}


export async function getActiveBatchProgressById(id){
    return await fetch(ApiUrl.Batch.getBatchById.getPath(id))
        .then(handleHttpResponse)
        .catch( (err) => {
            if (err) {
                console.error("Failed to fetch all active batch, " + err);
            }
        })
        .then( res => {
            if (res) {
                return res;
            }
        })
}

export async function cancelBatchProgress(id, account, setLoading) {
    setLoading(true);
    // eslint-disable-next-line no-restricted-globals
    if (confirm("Are you sure you want to cancel the background process?")) {

        try {
            const res = await fetch(ApiUrl.Batch.cancelBatch.getPath(id, account), {method: 'POST', body: ''})
                .then(handleHttpResponse)
            console.log("Cancel Process Response ", res);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    } else {
        setLoading(false);
    }
}
